import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy,Component,EventEmitter,Input,OnDestroy,Output } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BehaviorSubject,firstValueFrom } from 'rxjs';
import { EventCategoriesEntity } from '../../../dave-data-module/entities/event-categories.entity';
import { EventCategoriesDataService } from '../../../dave-data-module/services/event-categories.service-data-service';

import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { AppDialogService } from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { CustomFormsModule } from '../../custom-forms.module';

@Component({
    selector: 'app-event-categories-input',
    standalone: true,
    imports: [CommonModule, CustomFormsModule, FontAwesomeModule, MatLegacyButtonModule, ReactiveFormsModule],
    templateUrl: './event-categories-input.component.html',
    styleUrls: ['./event-categories-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCategoriesInputComponent implements OnDestroy {
    @Input() control: FormControl<EventCategoriesEntity[]> = new FormControl<EventCategoriesEntity[]>([]);

    @Input() compactLayout = false;

    @Input() placeholder = 'Kategorien';

    @Input() required = false;
    @Input() disabled = false;

    @Input() set options(v: EventCategoriesEntity[] | null) {
        this._options$.next(Array.isArray(v) ? v : []);
    }

    get options(): EventCategoriesEntity[] {
        return this._options$.value;
    }

    @Output() categoryDeleted = new EventEmitter<EventCategoriesEntity>();
    @Output() categoryAdded = new EventEmitter<EventCategoriesEntity>();


    protected _options$ = new BehaviorSubject<EventCategoriesEntity[]>([]);

    MapFn = (o: EventCategoriesEntity) => o?.Name ?? '';
    CompareFn = (a?: EventCategoriesEntity, b?: EventCategoriesEntity) => a?.Id === b?.Id;

    constructor(private readonly eventCategoriesDataService: EventCategoriesDataService, private readonly appDialog: AppDialogService) {}

    ngOnDestroy(): void {
        this._options$.complete();
    }

    async addCategory(name: string) {
        const created = await this.eventCategoriesDataService.addEventCategory({ Name: name });
        if (created) {
         //   this._options$.next([...this._options$.value, created]);


            const current = this.control.value ?? [];
            if (!current.some(c => c.Id === created.Id)) {
                this.control.setValue([...current, created]);
                this.control.markAsDirty();
                this.control.markAsTouched()
            }

            this.categoryAdded.emit(created);
        }
    }

    async deleteCategory(opt: EventCategoriesEntity, event: MouseEvent) {
        event?.stopPropagation();
        const response = await firstValueFrom(this.appDialog.OpenConfirmationDialog({ paragraph: `Kategorie ${opt.Name} wirklich löschen?`, styleDelete: true }));
        if (!response?.[0]) return;

        await this.eventCategoriesDataService.deleteEventCategory({ Id: opt.Id.toString() });
        this._options$.next(this._options$.value.filter((o) => o.Id !== opt.Id));

        const nextVal = (this.control.value ?? []).filter(o => o.Id !== opt.Id);
        this.control.setValue(nextVal);
        this.categoryDeleted.emit(opt);
    }
}
